import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoConfiguracao } from 'src/app/shared/models/projeto-configuracao.model';
import { PontosCriticosTipos } from '../../models/pontos-criticos-tipos.model';
import { PontosCriticosTiposService } from '../../services/pontos-criticos-tipos.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-pontos-criticos-tipos-edit',
  templateUrl: './pontos-criticos-tipos-edit.component.html',
  styleUrls: ['./pontos-criticos-tipos-edit.component.scss']
})
export class PontosCriticosTiposEditComponent extends BaseFormComponent<PontosCriticosTipos> implements OnInit {

  actionLabel: string = 'Novo';

  constructor(
    private myService: PontosCriticosTiposService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['projetos/admin-spgg/pontos-criticos-tipos']);
  }

  getDataCreate(): ProjetoConfiguracao {
    let data: ProjetoConfiguracao;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: PontosCriticosTipos) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: PontosCriticosTipos) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/pontos-criticos-tipos/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
